import React from "react";
import PropTypes from "prop-types";
import Btn from "../../../../components/atoms/Btn";

function PositionPickerIcon({
  hasError,
  isLoading,
  submit,
  clear,
  openModal,
  isEmpty,
  isSame,
}) {
  const contCl = `show-parent-focus tw-text-right tw-absolute tw-inset-y-0 tw-flex tw-items-center tw-right-0`;
  const btnCl = "tw-m-0.5 tw-mr-1 tw-px-1 tw-border-l border-2 tw-w-5";

  if (isLoading) {
    return (
      <div
        data-tooltip="searching...."
        data-tooltip-class="genome-browser-small-tooltip"
        className={contCl}
      >
        <div className={btnCl}>
          <i className="fa fa-circle-o-notch fa-spin tw-text-sky-500" />
        </div>
      </div>
    );
  }

  if (isEmpty || (hasError && !isLoading)) {
    return (
      <div
        className={contCl}
        data-tooltip="show help"
        data-tooltip-class="genome-browser-small-tooltip"
      >
        <Btn onSubmit={openModal} className={btnCl}>
          <i className="fa fa-info tw-text-blue-500" />
        </Btn>
      </div>
    );
  }

  if (isSame) {
    return (
      <div
        data-tooltip="clear input"
        data-tooltip-class="genome-browser-small-tooltip"
        className={contCl}
      >
        <Btn onSubmit={clear} className={btnCl}>
          <i className="fa fa-times color-3" />
        </Btn>
      </div>
    );
  }

  return (
    <div
      className={contCl}
      data-tooltip="search"
      data-tooltip-class="genome-browser-small-tooltip"
    >
      <Btn onSubmit={submit} className={btnCl}>
        <i className="fa fa-search color-1" />
      </Btn>
    </div>
  );
}

PositionPickerIcon.propTypes = {
  isSame: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  clear: PropTypes.func.isRequired,
};

PositionPickerIcon.defaultProps = {};

export default PositionPickerIcon;
